export default __webpack_public_path__ + "static/media/notes.f51a0750.svg";